import { Input } from 'antd'
import classNames from 'classnames'
import styles from './InputArea.module.css'

interface Props {
  value?: string
  onChange?: any
  className?: string
  placeholder?: string
  maxLength?: number
}

export default function InputArea({
  value,
  onChange,
  placeholder,
  maxLength = 1000,
  className,
}: Props) {
  const handleClear = () => {
    onChange?.('')
  }

  return (
    <div className={classNames(styles.inputArea, className)}>
      <Input.TextArea
        maxLength={maxLength}
        autoSize={{ minRows: 3 }}
        showCount
        placeholder={placeholder}
        value={value}
        onChange={e => {
          onChange(e.target.value)
        }}
      ></Input.TextArea>
      <div
        className={classNames(
          'flex items-center text-neutral-800 text-xs',
          styles.clearBtn
        )}
      >
        <div className="h-4 w-px bg-neutral-300 mr-4"></div>
        <div className="flex items-center cursor-pointer" onClick={handleClear}>
          清空
        </div>
      </div>
    </div>
  )
}
